import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DateAndNoteApp from "./DateAndNote";
import Meteo from "@services/Meteo";
import { ArrowUpCircle } from "lucide-react";
const TopInfos = ({ props }) => {
  const { t } = useTranslation();
  const bgBlue = {
    background: "linear-gradient(180deg, #8077ec 0%, #B8B2F8 100%)",
    overflow: "hidden",
  };

  return (
    <Row>
      <Col xl="6" className="my-2">
        <div
          style={props.profile?.mode === "dark" ? {} : bgBlue}
          className={`p-3 text-white rounded h-100 ${
            props.profile?.mode === "dark" ? "bg-dark" : ""
          }`}
        >
          <Row>
            <Col md="8" className="my-2">
              <div className="fs-4 fw-bold">
                {t("good_morning")}, {props.profile?.data.full_name} 👋
              </div>
              <div className="my-2">
                <p className="fs-6">{t("dashboard_text")}</p>
                <a
                  href="/new-product"
                  className="text-dark rounded d-block mt-2 fs-6"
                >
                  <div className="d-flex align-items-center text-orange">
                    <ArrowUpCircle />{" "}
                    <span className="mx-2">{t("add_your_product")}</span>
                  </div>
                </a>
              </div>
            </Col>
            <Col md="3" className="my-2 d-none d-md-block">
              <div className="w-100">
                <img
                  width="100%"
                  height="100%"
                  className="w-100"
                  src="https://isomorphic-furyroad.vercel.app/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fupgrade-plan.deb629fe.webp&w=1920&q=75"
                  alt=""
                />
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <Col md="6" xl="3" className="my-2">
        <DateAndNoteApp t={t} mode={props.profile?.mode}  />
      </Col>
      <Col md="6" xl="3" className="my-2">
        <Meteo mode={props.profile?.mode} t={t} />
      </Col>
    </Row>
  );
};

export default TopInfos;
